export function setHeight(options: Highcharts.Options, height: number): void {
    options.chart = {
        ...options.chart,
        height,
    };
}

export function setTitle(options: Highcharts.Options, text: string): void {
    options.title = {
        ...options.title,
        text,
    };
}

export function setSubtitle(options: Highcharts.Options, text: string): void {
    options.subtitle = {
        ...options.subtitle,
        text,
    };
}

export function setXTitle(options: Highcharts.Options, text: string): void {
    if (Array.isArray(options.xAxis)) {
        throw new TypeError("xAxis should not be an array when setting title");
    }
    options.xAxis = {
        ...options.xAxis,
        title: {
            ...options.xAxis?.title,
            text,
        },
    };
}

export function setYTitle(options: Highcharts.Options, text: string): void {
    if (Array.isArray(options.yAxis)) {
        throw new TypeError("yAxis should not be an array when setting title");
    }
    options.yAxis = {
        ...options.yAxis,
        title: {
            ...options.yAxis?.title,
            text,
        },
    };
}

export function setChartFontSize(
    options: Highcharts.Options,
    fontSize: number,
): void {
    options.chart = {
        ...options.chart,
        style: {
            ...options.chart?.style,
            fontSize: `${fontSize}px`,
        },
    };
}

export function setXFormatter(
    options: Highcharts.Options,
    formatter: Highcharts.AxisLabelsFormatterCallbackFunction,
): void {
    if (Array.isArray(options.xAxis)) {
        throw new TypeError(
            "xAxis should not be an array when setting formatter",
        );
    }
    options.xAxis = {
        ...options.xAxis,
        labels: {
            ...options.xAxis?.labels,
            formatter,
        },
    };
}

export function rotateDataLabels(
    options: Highcharts.Options,
    rotate: boolean,
): void {
    const dataLabels = options.plotOptions?.series?.dataLabels;
    if (Array.isArray(dataLabels)) {
        throw new TypeError("dataLabels should not be an array when rotating");
    }
    options.plotOptions = {
        ...options.plotOptions,
        series: {
            ...options.plotOptions?.series,
            dataLabels: {
                ...dataLabels,
                rotation: rotate ? 270 : 0,
            },
        },
    };
}

export function setYFormatter(
    options: Highcharts.Options,
    formatter: Highcharts.AxisLabelsFormatterCallbackFunction,
): void {
    if (Array.isArray(options.yAxis)) {
        throw new TypeError(
            "yAxis should not be an array when setting formatter",
        );
    }
    options.yAxis = {
        ...options.yAxis,
        labels: {
            ...options.yAxis?.labels,
            formatter,
        },
    };
}

export function setYAngle(options: Highcharts.Options, angle: number): void {
    if (Array.isArray(options.yAxis)) {
        throw new TypeError(
            "yAxis should not be an array when setting formatter",
        );
    }
    options.yAxis = {
        ...options.yAxis,
        angle,
    };
}

export function disableXLabels(options: Highcharts.Options): void {
    if (Array.isArray(options.xAxis)) {
        throw new TypeError(
            "xAxis should not be an array when disabling labels",
        );
    }
    options.xAxis = {
        ...options.xAxis,
        tickWidth: 0,
        labels: {
            enabled: false,
        },
    };
}

export function addLabelSuffix(
    options: Highcharts.Options,
    suffix: string,
): void {
    const dataLabels = options.plotOptions?.series?.dataLabels;
    if (Array.isArray(dataLabels)) {
        throw new TypeError(
            "dataLabels should not be an array when adding label suffix",
        );
    }
    if (dataLabels?.format != null) {
        dataLabels.format += suffix;
    }

    if (options.yAxis != null) {
        if (Array.isArray(options.yAxis)) {
            throw new TypeError(
                "yAxis should not be an array when adding label suffix",
            );
        }
        if (options.yAxis.labels != null) {
            options.yAxis.labels.format += suffix;
        }
    }
}

export function setCategories(
    options: Highcharts.Options,
    categories: string[],
): void {
    if (Array.isArray(options.xAxis)) {
        throw new TypeError(
            "xAxis should not be an array when setting categories",
        );
    }
    options.xAxis = {
        ...options.xAxis,
        categories,
    };
}

export function setEvents(
    options: Highcharts.Options,
    events: Highcharts.SeriesEventsOptionsObject,
): void {
    options.plotOptions = {
        ...options.plotOptions,
        series: {
            ...options.plotOptions?.series,
            events,
        },
    };
}

export function setAnimation(
    options: Highcharts.Options,
    animation: boolean,
): void {
    options.plotOptions = {
        ...options.plotOptions,
        series: {
            ...options.plotOptions?.series,
            animation,
        },
    };
}

export function setStartAngle(
    options: Highcharts.Options,
    startAngle: number,
): void {
    if (Array.isArray(options.pane)) {
        throw new TypeError(
            "Pane should not be an array when setting start angle",
        );
    }
    options.pane = {
        ...options.pane,
        startAngle,
    };
}
